import React from 'react';
import { Yes } from '../icons/Icons';

const PageWelcome = (props) => {
  return (
    <div className="kids-quiz__page kids-quiz__page--welcome">
      <div>
        <h1>Getting to know you</h1>
        <p>This comprehensive, 2-minute questionnaire is designed to gain insights into your physiology, dietary preferences, and wellness goals. This enables our experts to craft a nutrient stack that's perfectly aligned with your individual requirements.</p>

        <div className="kids-quiz__question">
          <label>What's your name?</label>
          <input type="text" onChange={e => props.updateFirstName(e.target.value.replace(/(?:^|-)\S/g, a => a.toUpperCase()))} value={props.firstName}></input>
        </div>

        <div className={`${props.firstName ? '' : 'disabled'} btn btn--primary btn--arrow btn--lg `} onClick={() => props.nextPage('0')}>Get started</div>

        <ul>
          <li>
            <Yes />
            <div>
              <h5>Truly Personalised</h5>
              <p>Combine 7 nutrients with your flavour choice for your unique stack</p>
            </div>
          </li>
          <li>
            <Yes />
            <div>
              <h5>7-in-1 Gummy</h5>
              <p>That your body digests like food for higher absorption and efficacy</p>
            </div>
          </li>
          <li>
            <Yes />
            <div>
              <h5>Freshly Made</h5>
              <p>Made to order in the UK with ethically sourced, traceable ingredients</p>
            </div>
          </li>
          <li>
            <Yes />
            <div>
              <h5>Plant Based</h5>
              <p>Sugar-free and Vegan Society approved along with GMO free</p>
            </div>
          </li>
        </ul>
      </div>
      <div className="welcome-image" style={{ backgroundImage: "url(https://cdn.shopify.com/s/files/1/0232/9618/0301/files/hand.jpg?v=1716542214)" }}>
      </div>
    </div>
  );
}

export default PageWelcome;